import type { InspectedElement } from './types';

interface HighlightOverlayProps {
    inspectedElement: InspectedElement;
}

/**
 * Visual highlight overlay that appears over the hovered element
 */
export function HighlightOverlay({ inspectedElement }: HighlightOverlayProps) {
    const { rect, sentryAttributes } = inspectedElement;

    // Build the tooltip text
    const tooltipLines: string[] = [];
    if (sentryAttributes.component) {
        tooltipLines.push(sentryAttributes.component);
    }
    if (sentryAttributes.sourceFile) {
        tooltipLines.push(sentryAttributes.sourceFile);
    }
    if (sentryAttributes.element && sentryAttributes.element !== sentryAttributes.component) {
        tooltipLines.push(`<${sentryAttributes.element}>`);
    }

    const hasInfo = tooltipLines.length > 0;
    const tooltipText = hasInfo ? tooltipLines.join(' • ') : 'No Sentry data';

    // Calculate tooltip position
    const tooltipTop = rect.top - 28;
    const showAbove = tooltipTop > 0;

    return (
        <>
            {/* Highlight box */}
            <div
                data-element-inspector="highlight"
                className="pointer-events-none fixed z-[10001] border-2 border-accent-500 bg-accent-500/10"
                style={{
                    top: rect.top,
                    left: rect.left,
                    width: rect.width,
                    height: rect.height,
                }}
            />

            {/* Tooltip */}
            <div
                data-element-inspector="tooltip"
                className="pointer-events-none fixed z-[10002] max-w-[400px] truncate rounded bg-gray-900 px-2 py-1 text-white text-xs shadow-lg"
                style={{
                    top: showAbove ? tooltipTop : rect.bottom + 4,
                    left: rect.left,
                }}
            >
                {tooltipText}
            </div>
        </>
    );
}
